<!--
 * @Descripttion: 活动详情
 * @Author: liaoyijun
 * @Date: 2021-10-22 14:00:01
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-03 10:51:38
-->
<template>
    <div class="center-context-item">
        <div class="center">
            <div class="center-context-title">
                <span>{{ curDetails.activityContent }}</span>
            </div>
            <div class="center-context-time">
                <span v-show="curDetails.activityCategoryName">【{{ curDetails.activityCategoryName }}】</span
                ><span> {{ curDetails.updateDate }}</span>
            </div>
            <div class="editor-content" v-html="curDetails.mainBody"></div>
        </div>
    </div>
</template>

<script>
import { activityDetail } from "@/api";
export default {
    name: "CulturalDetails",
    data() {
        return {
            curDetails: {},
        };
    },
    mounted() {
        this.benefitDetail();
    },
    activated() {
        this.benefitDetail();
    },
    methods: {
        // 获取福利详情
        async benefitDetail() {
            this.loading = true;
            try {
                const { code, body, message } = await activityDetail({
                    id: this.$route.query.id,
                });
                if (code === "0000") {
                    this.curDetails = body;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                this.$message.error("系统错误");
            }
            this.loading = false;
        },
    },
};
</script>
<style lang="scss" scoped>
@import "../style.scss";
</style>
